'use strict';

function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function checkForPolicyChanges(response) {
  return response.headers.get('X-Policy-Changes');
}

function parseJSON(response) {
  // .json() is part of isomorphic-fetch responses
  return response.json();
}

module.exports = {
  checkHttpStatus: checkHttpStatus,
  checkForPolicyChanges: checkForPolicyChanges,
  parseJSON: parseJSON
};